export default __webpack_public_path__ + "static/media/kyc-id.06946bf0.svg";